const propStateMapping = {
    keyphrase: (request, state) => state.keyphrase && request.setSearchQueryKeyphrase(state.keyphrase),
    page: (request, state) => request.setSearchOffset((state.itemsPerPage ?? request.getSearchLimit()) * ((state.page ?? 1) - 1) || 0),
    itemsPerPage: (request, state) => request.setSearchLimit(state.itemsPerPage),
    sortType: (request, state) => request.setSearchSortCriteriaName(state.sortType),
};
export default propStateMapping;
